<template>
  <div class="forgot-page">
    <UiContainer class="forgot-page__container">
      <div class="forgot-page__card-wrap">
        <UiCard class="forgot-page__card">
          <h1 class="forgot-page__title">Восстановление пароля</h1>
          <p v-if="sent" class="forgot-page__hint forgot-page__hint--success" role="status">
            Если аккаунт с адресом {{ email }} существует, мы отправили на него письмо со ссылкой
            для сброса пароля. Ссылка действует 1 час.
          </p>
          <template v-else>
            <p class="forgot-page__hint">
              Укажите email, с которым вы регистрировались, и мы отправим ссылку для сброса пароля.
            </p>
            <form class="forgot-page__form" @submit.prevent="submit">
              <div class="forgot-page__field">
                <label class="forgot-page__label" for="forgot-email">Email</label>
                <UiInput
                  id="forgot-email"
                  v-model="email"
                  type="email"
                  placeholder="email@example.com"
                  autocomplete="email"
                  required
                />
              </div>
              <p v-if="errorMessage" class="forgot-page__error" role="alert">{{ errorMessage }}</p>
              <UiButton type="submit" block :loading="loading">Отправить ссылку</UiButton>
            </form>
          </template>
          <p class="forgot-page__footer">
            <router-link to="/login" class="forgot-page__link">Вернуться ко входу</router-link>
          </p>
        </UiCard>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useAuthSession } from '@/modules/auth/public'
import UiButton from '@/shared/ui/UiButton.vue'
import UiCard from '@/shared/ui/UiCard.vue'
import UiContainer from '@/shared/ui/UiContainer.vue'
import UiInput from '@/shared/ui/UiInput.vue'

const authStore = useAuthSession()

const email = ref('')
const loading = ref(false)
const sent = ref(false)
const errorMessage = ref('')

async function submit() {
  const normalizedEmail = email.value.trim()
  if (!normalizedEmail) {
    errorMessage.value = 'Введите email'
    return
  }

  loading.value = true
  errorMessage.value = ''
  try {
    const result = await authStore.requestPasswordReset(normalizedEmail)
    if (result.success) {
      email.value = normalizedEmail
      sent.value = true
    } else {
      errorMessage.value = result.error || 'Не удалось отправить письмо'
    }
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.forgot-page {
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
}

.forgot-page__container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 32px;
}

.forgot-page__card-wrap {
  width: 100%;
  max-width: 400px;
}

.forgot-page__card {
  padding: 24px;
}

.forgot-page__title {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}

.forgot-page__hint {
  margin: 0 0 16px;
  font-size: 14px;
  color: #586578;
}

.forgot-page__hint--success {
  color: #047857;
}

.forgot-page__error {
  margin: 0;
  font-size: 14px;
  color: #b91c1c;
}

.forgot-page__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.forgot-page__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.forgot-page__label {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.forgot-page__footer {
  margin: 24px 0 0;
  text-align: center;
  font-size: 14px;
}

.forgot-page__link {
  color: #0f172a;
  font-weight: 500;
  text-decoration: none;
}

.forgot-page__link:hover {
  text-decoration: underline;
}
</style>
